// CancelFlow copy is English-only today, so keep the date locale explicit.
const PERIOD_END_LOCALE = 'en-US'

const PERIOD_END_DATE_OPTIONS: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  timeZone: 'UTC',
}

export function formatPeriodEnd(periodEnd: string | null): string | null {
  if (!periodEnd) return null

  const date = new Date(periodEnd)
  if (Number.isNaN(date.getTime())) return null

  return date.toLocaleDateString(PERIOD_END_LOCALE, PERIOD_END_DATE_OPTIONS)
}
